// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"


//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { useDispatch, useSelector } from "react-redux";

// actions
import { listChartColor } from "store/actions";
import AddEditModal from "../AddEdit/AddEditModal";
import { withTranslation } from "react-i18next";

const List = props => {
    //meta title
    document.title = `${props.t("Manage Chart Colors")}  | ${props.t("Admin")}`;

    const { error, success, loading } = useSelector(state => ({
        loading: state.ConfigurationsChartColor.loading,
        error: state.ConfigurationsChartColor.error,
        success: state.ConfigurationsChartColor.success,
    }));

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);

    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };

    // edit 
    const handleClick = data => {
        setIsEdit(true);
        SetItemData(data)
        toggle();
    };

    // list
    const fetchListChartColor = (filterData) => {
        dispatch(listChartColor(filterData, (res) => {
            if (res?.status === 'success') {
                SetTableData(res?.data)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchListChartColor()
    }, [])

    return (
        <React.Fragment>
            <AddEditModal
                modal={modal}
                toggle={toggle}
                isEdit={isEdit}
                itemData={itemData}
                fetchChartColorListData={() => fetchListChartColor()}
            />
            <div className="page-content table-main-config-chartcolor-list">
                <div className="container-fluid">
                    <Breadcrumbs title={props.t("Configuration")} breadcrumbItem={props.t("Manage Chart Colors")} />

                    <Row>
                        <Col lg="12">
                            <div className="table-responsive">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <Table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="main-data-fix-width">{props.t("Name")}</th>
                                                    <th>{props.t("Color")}</th>
                                                    <th>{props.t("R")}</th>
                                                    <th>{props.t("G")}</th>
                                                    <th>{props.t("B")}</th>
                                                    <th>{props.t("Gradient")}</th>
                                                    <th style={{ textAlign: "center", paddingRight: "25px" }}>{props.t("Action")}</th>
                                                </tr>
                                            </thead>
                                            {
                                                tableData?.chart_colors?.length <= 0
                                                    ?
                                                    <tr>
                                                        <td colSpan="5" className="text-center no-record-found">{props.t("No Record Found")}</td>
                                                    </tr>
                                                    :
                                                    <tbody>
                                                        {(tableData?.chart_colors || []).map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item?.key_name?.split('_')
                                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                    .join(' ')}
                                                                </td>
                                                                <td><input type="color" value={item?.hex} readOnly disabled /></td>
                                                                <td>{item?.rgb?.split(",")[0] || 'N/A'}</td>
                                                                <td>{item?.rgb?.split(",")[1] || 'N/A'}</td>
                                                                <td>{item?.rgb?.split(",")[2] || 'N/A'}</td>
                                                                <td>{item?.hex || 'N/A'}</td>

                                                                <td>
                                                                    <ul className="list-unstyled hstack gap-1 mb-0">
                                                                        <li>
                                                                            <span
                                                                                className="btn btn-sm btn-soft-info"
                                                                                onClick={() => {
                                                                                    handleClick(item);
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-edit" id={`edittooltip${item?.id}`} />
                                                                                <UncontrolledTooltip placement="top" target={`edittooltip${item?.id}`}>
                                                                                    {props.t("Edit")}
                                                                                </UncontrolledTooltip>
                                                                            </span>
                                                                        </li>

                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                            }

                                        </Table>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

List.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(List);
